import React, { Component } from 'react'

import ChatBoxRT from 'chat-box-rt'
import config from './configs/rt_pro';

export default class App extends Component {
  render () {
    return (
      <div>
        <ChatBoxRT
          config={config}
        />
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/App.js